import { IIconProps } from '../interface';

const SvgGuinea = ({ width = 56, height = 56 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.7394 1.74169C34.706 0.616109 31.4251 0 28 0C24.5752 0 21.2943 0.616109 18.2612 1.74147L17.0437 28L18.261 54.2585C21.2943 55.384 24.5752 56 28 56C31.4252 56 34.706 55.384 37.7394 54.2583L38.9568 28L37.7394 1.74169Z"
      fill="#FFDA44"
    />
    <path
      d="M0 28C0 40.0389 7.5985 50.3022 18.2609 54.2583V1.74146C7.5985 5.69777 0 15.9609 0 28Z"
      fill="#D80027"
    />
    <path
      d="M56.0001 28C56.0001 15.9609 48.4016 5.69777 37.7391 1.74146V54.2584C48.4016 50.3022 56.0001 40.0389 56.0001 28Z"
      fill="#6DA544"
    />
  </svg>
);

export default SvgGuinea;
